<template>
<div class="pk-hp-outer">
<div class="pk-hp-container">
  This page is under construction...
</div>
</div>
</template>

<script>
import Vue from 'vue';
export default Vue.extend({
  mounted() {
    if (this.$matomo) {
      this.$matomo.trackPageView('Help');
    }
  }
});
</script>


<style lang="scss" scoped>

.pk-hp-outer {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.pk-hp-container {
  width: 700px;
  padding-top: 50px;
  margin-left: calc((100vw - 700px) / 2);
  // font-family: 'Times New Roman', Times, serif;
  
  .title {
    font-weight: 700;
    font-size: 1.5em;
    color: #337ab7;
  }

  .subtitle {
    font-size: 1.2em;
    color: #337ab7;
  }

  .deactivate-piwik-link {
    text-decoration: underline !important;
    text-decoration-color: #337ab7 !important;
  }
}
</style>